var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kendo-tooltip',{attrs:{"title":_vm.text,"position":'top'}},[_c('b-btn',{attrs:{"variant":_vm.variant,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{class:_vm.icon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }